import {
  PRESENTE,
  PRESENTE_FAIL,
  PRESENTE_RESET,
  PRESENTE_SUCCESS,
} from "../ActionTypes";
import presenteInitialState from "../initialState/presenteInitialState";

const presente = (state, { payload, type }) => {
  switch (type) {
    case PRESENTE:
      return {
        ...state,
        presente: {
          ...state.presente,
          loading: true,
          error: false,
          data: null,
        },
      };
    case PRESENTE_SUCCESS:
      return {
        ...state,
        presente: {
          ...state.presente,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case PRESENTE_FAIL:
      return {
        ...state,
        presente: {
          ...state.presente,
          loading: false,
          error: payload,
          data: null,
        },
      };
    case PRESENTE_RESET:
      return presenteInitialState;
    default:
      return state;
  }
};

export default presente;
